import { render } from "./CRM_Customer_Dialog.vue?vue&type=template&id=da3ccdec&scoped=true&ts=true"
import script from "./CRM_Customer_Dialog.vue?vue&type=script&lang=ts"
export * from "./CRM_Customer_Dialog.vue?vue&type=script&lang=ts"

import "./CRM_Customer_Dialog.vue?vue&type=style&index=0&id=da3ccdec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3ccdec"]])

export default __exports__